const manifest = require('../../../../deploy-manifest.json');

window.versionAsset = function (url) {
  let version = Date.now();

  if (manifest.commit) {
      version = manifest.commit;
  }

  return `${url}?v=${version}`;
};


if (document.querySelector('.car-img-slider')) {
    var swiper = new Swiper('.car-img-slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: false
    });
}
if (document.querySelector('#swiper-review')) {
//review
  var swiperReview = new Swiper('#swiper-review', {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 40,
      }
    }
  });
}

//cities
if (document.querySelector('#swiper-cities')) {

  var swiper = new Swiper('#swiper-cities', {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: true,
    loopFillGroupWithBlank: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      300: {
        slidesPerGroup: 1,
        slidesPerView: 2
      },
      992: {
        slidesPerGroup: 1
      }
    }
  });
}
if (document.querySelector('.car-carousel')) {
  var carousel = new Swiper('.car-carousel', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
if (document.querySelector('.car-carousel-inner')) {
  var carousel_inner = new Swiper('.car-carousel-inner', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.swiper-pagination-inner',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-inner',
      prevEl: '.swiper-button-prev-inner',
    },
  });
}
var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl);
});

var element = document.querySelector('#rabat-block');
if (element) {
  window.addEventListener('scroll', function () {
    var position = element.getBoundingClientRect();

    // checking for partial visibility
    if (position.top < window.innerHeight && position.bottom >= 0) {
      $('.rabatInfo__items .item').addClass('hero');
    }
  });
}

$('.car-items .item .moreInfo').click(function () {
  $(this).parents('.item').find('.car-additional-features').fadeIn();
  return false;
});
$('.car-items .item .car-additional-features .modal__close').click(function () {
  $(this).parents('.car-additional-features').fadeOut();
  return false;
});

var bookingScroll = $('section.booking-page .car-items .item');

if (bookingScroll.length) {
  $(window).scroll(function () {
    var heightContent = $('.booking-page .content').height();

    bookingScroll.removeClass('booking-fixed');

    if (heightContent > 1600 && $(window).scrollTop() > 334) {
      bookingScroll.addClass('booking-fixed');
    }
  });
}

//tabs
$(document).on('click', '.nav-tabs .tablinks', function (evt) {
  // Declare all variables
  var i, tablinks, toggle = $(this).data('toggle');
  $('.tabcontent').hide();
  $('.tablinks').removeClass('active');
  // Show the current tab, and add an 'active' class to the button that opened the tab
  $(toggle).show();
  $(this).addClass('active');
});

$('.launch_datepicker').on('click', function () {
    $('.car-search-form #from-date-search-bar-item').focus();
});

//burger menu
const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
// const backLink = `<li class='nav-item d-sm-none'>
//   <a class='nav-link nav-back-link' href='javascript:;'>
//     <i class='icon arrow-left'></i> Back
//   </a>
// </li>`

navExpand.forEach(item => {
  // item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink);
  if (item.querySelector('.nav-link')) {
    item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'));
    item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'));
  }
})

var ham = document.getElementById('ham')
if (ham) {
  ham.addEventListener('click', function () {
    document.body.classList.toggle('nav-is-toggled');
  });
}

$('.car-img-slider .swiper-wrapper').each(function () {
  var $el = $(this).parent();
  var selector = '.'+$el.attr('class').replace(/ /g, '.');

  new Swiper($el[0], {
    speed: 400,
    spaceBetween: 15,
    grabCursor: true,
    pagination: {
      el: selector+' .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    preloadImages: false,
    lazy: true,
    observer: true,
    observeParents: true,
  });
});

$('body').on('click', '.swiper-navigation a', function (e) {
  e.preventDefault();

  if($(this).hasClass('slide-prev')) {
    $(this).parent().parent()[0].swiper.slidePrev();
  } else if($(this).hasClass('slide-next')) {
    $(this).parent().parent()[0].swiper.slideNext();
  }
});

$('.car-img img, img.car-img').on('error', function () {
  this.src = '/img/car_placeholder_new.png';
});

$(document).ready(function () {
  lazyload();

  var _targettedModal;
  var _triggers = document.querySelectorAll('[data-modal-trigger]');
  var _dismiss = document.querySelectorAll('[data-modal-dismiss]');
  var modalActiveClass = "is-modal-active";

  window.showModal = function (el) {
    _targettedModal = document.querySelector('[data-modal-name="'+ el + '"]');
    _targettedModal.classList.add(modalActiveClass);
  }

  window.hideModal = function (event) {
    if (event === undefined || event.target.hasAttribute('data-modal-dismiss')) {
      _targettedModal.classList.remove(modalActiveClass);
    }
  }

  window.bindEvents = function (el, callback) {
    for (let i = 0; i < el.length; i++) {
      (function (i) {
        el[i].addEventListener('click', function (event) {
          callback(this, event);
        });
      })(i);
    }
  }

  window.triggerModal = function () {
    bindEvents(_triggers, function (that) {
      showModal(that.dataset.modalTrigger);
    });
  }

  window.dismissModal = function () {
    bindEvents(_dismiss, function (that) {
      hideModal(event);
    });
  }

  window.initModal = function () {
    triggerModal();
    dismissModal();
  }

  initModal();

  $('.intl-phone-input').each(function () {
    var hiddenInput = $(this).attr('name');
    if ($(this).data('hiddenInput')) {
      hiddenInput = $(this).data('hiddenInput');
    }

    $(this).intlTelInput({
      preferredCountries: [],
      hiddenInput: hiddenInput,
      separateDialCode: false,
      initialCountry: countryIso,
      /*geoIpLookup: function (callback) {
          $.get('https://ipinfo.io', function () {}, "jsonp").always(function (resp) {
              var countryCode = (resp && resp.country) ? resp.country : "";
              callback(countryCode);
          });
      },*/
      utilsScript: '/vendor/intl-tel-input/build/js/utils.js',
    });
  });

  /*$('#make-account').on('change', function (e) {
    if ($(this).is(':checked')) {
      $('.password-inputs-holder').stop().slideDown();
    } else {
      $('.password-inputs-holder').stop().slideUp();
    }
  });*/

  $('input[name=customer_type]').on('change', function (e) {
    if ($('input[name=customer_type]:checked').val() == 1) {
      $('.business-details-wrapper').stop().slideDown();
    } else {
      $('.business-details-wrapper').stop().slideUp();
    }
  });

  if (document.querySelector('.car-carousel')) {
    var carousel = new Swiper('.car-carousel', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  $('.menu__item-logo')
    .attr('data-bs-toggle', 'collapse')
    .attr('data-bs-target', '#navbarSupportedContent.show')
    .addClass('nav-close-item')
    .attr('aria-expanded', 'true');

});

$.fn.scrollDivToElement = function(childEl) {
  if (! this.length) return this;

  return this.each(function() {
    let parentEl = $(this);

    if (childEl.length > 0) {
      parentEl.scrollTop(
        parentEl.scrollTop() - parentEl.offset().top + childEl.offset().top - (parentEl.outerHeight() / 2) + (childEl.outerHeight() / 2)
      );
    }
  });
};
